import Home from "../../views/administrador/Home";
import addUsers from "../../views/administrador/userAdministration/addUsers";
import administrationsUsers from "../../views/administrador/userAdministration/administrationsUsers";

//----------Ventas-------------
import Routes_Ventas from "../routes/ventas/routes";


//----------Produccion-------------
import RoutesProduccion from "../routes/produccion/routes";


//----------Compras-------------
import routes_compras from "../routes/compras/routes";

//----------Autorizacion-------------
import routes_autorizaciones from "../routes/autorizaciones/routes";

//----------Logistica-------------
import routes_logistica from "../routes/logistica/routes";



const dashboardRoutes = [
  {
    path: "/home",
    name: "Home",
    icon: "pe-7s-home",
    component: Home,
  },
 
  {
    path: "/addUser",
    name: "Add User",
    icon: "pe-7s-add-user",
    component: addUsers,
  },
  {
    path: "/user",
    name: "User Administration",
    icon: "pe-7s-users",
    component: administrationsUsers,
  },
  {
    path: "/manageUser",
    name: "Manage Users",
    icon: "pe-7s-user",
    component: administrationsUsers,
    doNotShow: true,
  },


  //Routes Ventas
  Routes_Ventas[0],

  //Routes Produccion
  RoutesProduccion[0],

  //Routes Compras
  routes_compras[0],  
  routes_compras[1], //Solicitud_Compras

  //Routes Autorizaciones
  routes_autorizaciones[0], 

  //Routes Logistica
  routes_logistica[0], 
  routes_logistica[1], 
  routes_logistica[2], //----> Despacho Combustible 
  routes_logistica[3], //----> Control Combustible Cartelera 
  routes_logistica[4], //----> Control Combustible Facturacion
  routes_logistica[5], //----> FfactSAP


  {
    path: 3,
    name: "Ventas",
    icon: "pe-7s-credit",
    component: Routes_Ventas
  }, 

  {
    path: 2,
    name: "Produccion",
    icon: "pe-7s-box1",
    component: RoutesProduccion
  }, 
  
  {
    path: 11,
    name: "Compras",
    icon: "pe-7s-cart",
    component: routes_compras
  }, 

  {
    path: 12,
    name: "Autorizaciones",
    icon: "pe-7s-like2",
    component: routes_autorizaciones
  },
  
  {
    path: 13,
    name: "Logistica",
    icon: "pe-7s-map",
    component: routes_logistica
  },  

  { redirect: true, path: "/", to: "/home", name: "Home" },
];
export default dashboardRoutes;
